<template>
  <div class="account-list-container">
    <div class="header-toolbar">
      <h2>账号管理</h2>
      <div>
        <el-button type="primary" @click="goToCreateAccount">新增账号</el-button>
        <el-button 
          type="danger" 
          @click="batchDeleteAccounts" 
          :disabled="selectedAccounts.length === 0"
          style="margin-left: 10px;"
        >
          批量删除 ({{ selectedAccounts.length }})
        </el-button>
        <el-button type="info" @click="goBack" style="margin-left: 10px;">返回订单列表</el-button>
      </div>
    </div>

    <div class="search-bar" style="margin: 20px 0; padding: 15px; background: #fff; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
      <el-input 
        v-model="searchForm.username" 
        placeholder="输入用户名搜索" 
        style="width: 200px; margin-right: 10px;"
      ></el-input>
      <el-select 
        v-model="searchForm.role" 
        placeholder="选择角色" 
        style="width: 150px; margin-right: 10px;"
      >
        <el-option label="超级管理员" value="super_admin"></el-option>
        <el-option label="管理员" value="admin"></el-option>
        <el-option label="客户" value="customer"></el-option>
      </el-select>
      <el-button type="primary" @click="getAccountList">搜索</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </div>

    <div class="table-container" style="background: #fff; padding: 20px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
      <el-table 
        :data="accountList" 
        border 
        stripe 
        style="width: 100%;"
        row-key="id"
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column label="ID" prop="id" width="80" align="center"></el-table-column>
        <el-table-column label="用户名" prop="username" align="center"></el-table-column>
        <el-table-column label="真实姓名" prop="realName" align="center"></el-table-column> <!-- 新增realName字段 -->
        <el-table-column label="角色" prop="role" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.role === 'super_admin'">超级管理员</span>
            <span v-if="scope.row.role === 'admin'">管理员</span>
            <span v-if="scope.row.role === 'customer'">客户</span>
          </template>
        </el-table-column>
        <el-table-column label="账号状态" prop="status" align="center"> 
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">正常</span>
            <span v-if="scope.row.status === 1" style="color: red;">禁用</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTimeStr" align="center"></el-table-column>
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="goToEditAccount(scope.row.id)">编辑</el-button>
            <el-button type="text" style="color: red;" @click="deleteAccount(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination" style="margin-top: 20px; text-align: right;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getAccountPage, deleteAccount as deleteAccountApi, batchDeleteAccounts } from '@/api/account' 
import { Message } from 'element-ui'

export default {
  name: 'AccountList',
  data() {
    return {
      accountList: [],
      total: 0,
      loading: false,
      pageNum: 1, 
      pageSize: 10, 
      selectedAccounts: [], // 选中的账号
      searchForm: { 
        username: '',
        role: ''
      }
    }
  },
  created() {
    this.getAccountList();
  },
  methods: {
    goToCreateAccount() {
      this.$router.push('/account/create');
    },
    goBack() {
      this.$router.push('/admin-order-list');
    },
    goToEditAccount(id) {
      this.$router.push({ path: '/account/create', query: { id } });
    },

    getAccountList() {
      this.loading = true;
      const queryDTO = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.searchForm
      };
      getAccountPage(queryDTO)
        .then(res => {
          this.loading = false;
          if (res.code === 200) {
            this.accountList = res.data || []; 
            this.total = res.total || 0; 
          } else {
            Message.error('获取账号列表失败：' + (res.msg || '未知错误'));
            this.accountList = [];
            this.total = 0;
          }
        })
        .catch(err => {
          this.loading = false;
          console.error('获取账号列表异常：', err);
          console.error('后端错误详情：', err.response?.data);
          Message.error('获取账号列表失败，请重试');
          this.accountList = [];
          this.total = 0;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAccountList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getAccountList();
    },
    resetSearch() {
      this.searchForm = { username: '', role: '' };
      this.pageNum = 1;
      this.pageSize = 10;
      this.getAccountList();
    },
    deleteAccount(id) {
      this.$confirm('确认删除该账号吗？此操作不可恢复', '提示', {
        type: 'warning'
      })
        .then(() => {
          deleteAccountApi(id)
            .then(res => {
              if (res.code === 200) {
                Message.success('账号删除成功');
                this.getAccountList();
              } else {
                Message.error('删除账号失败：' + (res.msg || '未知错误'));
              }
            })
            .catch(err => {
              console.error('删除账号异常：', err);
              Message.error('删除账号失败，请重试');
            });
        })
        .catch(() => {});
    },

    handleSelectionChange(selection) {
      this.selectedAccounts = selection;
    },

    batchDeleteAccounts() {
      if (this.selectedAccounts.length === 0) {
        Message.warning('请先选择要删除的账号');
        return;
      }

      this.$confirm(
        `确定删除选中的 ${this.selectedAccounts.length} 个账号？此操作不可恢复！`,
        '批量删除警告',
        {
          type: 'warning',
          confirmButtonText: '确定删除',
          cancelButtonText: '取消'
        }
      )
        .then(() => {
          const ids = this.selectedAccounts.map(account => account.id);
          batchDeleteAccounts(ids)
            .then(res => {
              if (res.code === 200) {
                Message.success(res.msg || '批量删除成功');
                this.selectedAccounts = [];
                this.getAccountList();
              } else {
                Message.error('批量删除失败：' + (res.msg || '未知错误'));
              }
            })
            .catch(err => {
              console.error('批量删除账号异常：', err);
              Message.error('批量删除失败，请重试');
            });
        })
        .catch(() => {});
    }
  }
}
</script>

<style scoped>
.account-list-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}
.header-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.el-table th, .el-table td {
  text-align: center;
  vertical-align: middle;
}
</style>